;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="87f5126e-f2df-4107-ab0a-7948a53a1a2b",e._sentryDebugIdIdentifier="sentry-dbid-87f5126e-f2df-4107-ab0a-7948a53a1a2b")}catch(e){}}();
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63],{

/***/ 94192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_redux_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34705);
/* harmony import */ var src_redux_slice_User_User__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85195);
/* harmony import */ var src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7847);







var withAuthorization = function(allowedRoles) {
    return function(WrappedComponent) {
        var Wrapper = function(props) {
            var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
            var userType = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .C)(src_redux_slice_User_User__WEBPACK_IMPORTED_MODULE_4__/* .userReducer */ .M3).user.type;
            var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
            (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
                var timer = setTimeout(function() {
                    setIsLoading(false);
                }, 100);
                return function() {
                    return clearTimeout(timer);
                };
            }, []);
            (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
                if (isLoading) return;
                if (!userType) return; // Chưa có userType, không làm gì
                if (router.pathname === "/") {
                    if (userType === src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_5__/* .UserType.TEACHER */ .F.TEACHER) router.push("/teachers");
                    else if (userType === src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_5__/* .UserType.STUDENT */ .F.STUDENT) router.push("/courses");
                } else if (!allowedRoles.includes(userType)) {
                    router.replace("/courses");
                }
            }, [
                router.pathname,
                userType,
                isLoading
            ]);
            // Chỉ loading khi đang loading
            if (isLoading) return null;
            // Nếu chưa có userType, có thể show loading hoặc null
            if (!userType) return null;
            // Nếu userType không hợp lệ, không render component
            if (!allowedRoles.includes(userType)) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        };
        Wrapper.displayName = "WithAuthorization(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
        return Wrapper;
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withAuthorization);


/***/ }),

/***/ 40392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



var ButtonText = function(param) {
    var title = param.title, onClick = param.onClick, _className = param.className, className = _className === void 0 ? "" : _className, link = param.link, _size = param.size, size = _size === void 0 ? "small" : _size, _full = param.full, full = _full === void 0 ? false : _full, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _type = param.type, type = _type === void 0 ? "button" : _type, _isPaddingHorizontal = param.isPaddingHorizontal, isPaddingHorizontal = _isPaddingHorizontal === void 0 ? true : _isPaddingHorizontal, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var isDisabled = disabled || loading;
    var textSizeClass = size === "small" ? "text-[0.875rem] leading-4" : size === "medium" ? "text-[1rem] leading-6" : "text-lg leading-6.5";
    var paddingVerticalClass = size === "small" ? "py-2" : size === "medium" ? "py-2" : "py-2.8";
    var paddingHorizontalClass = isPaddingHorizontal ? size === "small" ? "px-7" : size === "medium" ? "px-8" : "px-9" : "";
    var fullWidthClass = full ? "block w-full" : "inline-block w-fit";
    var disabledClass = isDisabled ? "text-gray-2 cursor-not-allowed" : "text-bw-1 cursor-pointer";
    var componentClass = "\n    ".concat(className, "\n    text-center\n    ").concat(fullWidthClass, "\n    ").concat(paddingVerticalClass, "\n    ").concat(paddingHorizontalClass, "\n    ").concat(disabledClass, "\n    ").concat(textSizeClass, "\n    font-semibold\n    underline\n  ").trim();
    var buttonContent = loading ? "Loading..." : title;
    if (link) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: link,
            className: componentClass,
            "aria-disabled": isDisabled,
            children: buttonContent
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: type,
        className: componentClass,
        onClick: onClick,
        disabled: isDisabled,
        children: buttonContent
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonText);


/***/ }),

/***/ 90522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26449);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87017);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82684);







var SappDrawerV2 = function(_param) {
    var open = _param.open, handleCancel = _param.handleCancel, width = _param.width, title = _param.title, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "open",
        "handleCancel",
        "width",
        "title",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        open: open,
        title: undefined,
        onClose: handleCancel,
        width: width !== null && width !== void 0 ? width : "45%",
        closeIcon: false
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full bg-white",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative bg-bw-1 px-8 py-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pr-10 text-2xl font-medium text-white",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-8 top-1/2 -translate-y-2/4 cursor-pointer",
                            onClick: handleCancel,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                                type: "cross",
                                className: "text-white"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-8 py-6",
                    children: children
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SappDrawerV2);


/***/ }),

/***/ 22093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ExamInformation_ExamEditDrawer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(21967);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(37559);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28598);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js + 1 modules
var UploadOutlined = __webpack_require__(54213);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 2 modules
var icons = __webpack_require__(34648);
// EXTERNAL MODULE: ./src/components/base/button/ButtonText.tsx
var ButtonText = __webpack_require__(40392);
// EXTERNAL MODULE: ./src/components/base/button/SappButton.tsx
var SappButton = __webpack_require__(98971);
// EXTERNAL MODULE: ./src/components/base/drawer/SappDrawerV2.tsx
var SappDrawerV2 = __webpack_require__(90522);
// EXTERNAL MODULE: ./src/components/base/modal/SappModalV3.tsx
var SappModalV3 = __webpack_require__(21849);
// EXTERNAL MODULE: ./src/components/base/select/HookFormSelect.tsx
var HookFormSelect = __webpack_require__(88012);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(35447);
;// CONCATENATED MODULE: ./src/utils/helpers/plurarize.ts
var pluralize = function(word, count, pluralForm) {
    if (count === 1) return word;
    if (pluralForm) return pluralForm // Use custom plural form if provided
    ;
    // Common pluralization rules
    if (word.endsWith("y") && !/[aeiou]y$/i.test(word)) {
        return word.slice(0, -1) + "ies" // city → cities
        ;
    }
    if (/(s|sh|ch|x|z)$/.test(word)) {
        return word + "es" // bus → buses, box → boxes
        ;
    }
    if (word.endsWith("f")) {
        return word.slice(0, -1) + "ves" // leaf → leaves
        ;
    }
    if (word.endsWith("fe")) {
        return word.slice(0, -2) + "ves" // knife → knives
        ;
    }
    return word + "s" // Default rule: just add "s"
    ;
};

// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js
var message = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js
var upload = __webpack_require__(48814);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 9 modules
var es_button = __webpack_require__(33336);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(75367);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(72808);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(97478);
;// CONCATENATED MODULE: ./src/constants/form.ts
var zodMsg = {
    required: "This field is required"
};

// EXTERNAL MODULE: ./src/hooks/useSelectExams.tsx
var useSelectExams = __webpack_require__(34194);
// EXTERNAL MODULE: ./src/pages/api/class/index.ts
var api_class = __webpack_require__(14577);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(5137);
;// CONCATENATED MODULE: ./src/components/profile/ExamInformation/ExamEditDrawer.tsx





















var allowedTypes = [
    "image/png",
    "image/jpeg",
    "image/jpg"
];
var ExamEditDrawer = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, classId = param.classId, onSuccess = param.onSuccess, remainingChanges = param.remainingChanges, currentValue = param.currentValue;
    var ref;
    var ref1 = (0,react.useState)(false), openConfirmModal = ref1[0], setOpenConfirmModal = ref1[1];
    var validationSchema = lib.z.object({
        note: lib.z.array(lib.z.any(), {
            message: zodMsg.required
        }).min(1, {
            message: zodMsg.required
        }),
        examination_subject_id: lib.z.object({
            label: lib.z.string({
                required_error: zodMsg.required
            }).min(1, {
                message: zodMsg.required
            }),
            value: lib.z.string({
                required_error: zodMsg.required
            }).min(1, {
                message: zodMsg.required
            })
        }, {
            message: zodMsg.required
        })
    });
    var ref2 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(validationSchema)
    }), control = ref2.control, handleSubmit = ref2.handleSubmit, reset = ref2.reset, setValue = ref2.setValue, watch = ref2.watch, errors = ref2.formState.errors;
    var fileList = watch("note");
    var getUploadProps = function(onChange) {
        return {
            beforeUpload: function(file) {
                var isValidType = allowedTypes.includes(file.type);
                if (!isValidType) {
                    message/* default.error */.ZP.error("".concat(file.name, " is not a valid image file (only PNG, JPG, and JPEG allowed)."));
                    return upload/* default.LIST_IGNORE */.Z.LIST_IGNORE;
                }
                onChange([
                    file
                ]) // Manually update form state
                ;
                return false // Prevent default upload behavior
                ;
            },
            onRemove: function() {
                setValue("note", []);
            }
        };
    };
    var ref3 = (0,useSelectExams/* default */.Z)(classId), exams = ref3.exams, hasNextPage = ref3.hasNextPage, fetchNextPage = ref3.fetchNextPage, refetch = ref3.refetch;
    var ref4 = (0,es.useMutation)({
        mutationFn: function(param) {
            var examination_subject_id = param.examination_subject_id, note = param.note;
            var formData = new FormData();
            formData.append("examination_subject_id", examination_subject_id);
            note && formData.append("note", note[0]);
            return api_class/* ClassAPI.changeExamDate */.L.changeExamDate(classId, formData);
        },
        onSuccess: function(res) {
            if (res.data.success) {
                dist/* default.success */.ZP.success(res.data.data.message);
                onSuccess && onSuccess();
                setIsOpen(false);
                reset();
            }
            setOpenConfirmModal(false);
        }
    }), mutate = ref4.mutate, isChangingLoad = ref4.isLoading;
    var options = exams === null || exams === void 0 ? void 0 : (ref = exams.data) === null || ref === void 0 ? void 0 : ref.map(function(exam) {
        var ref;
        return {
            label: exam === null || exam === void 0 ? void 0 : (ref = exam.examination) === null || ref === void 0 ? void 0 : ref.name,
            value: exam === null || exam === void 0 ? void 0 : exam.id
        };
    }).filter(function(item) {
        return item.value !== currentValue;
    });
    var onSubmit = function(data) {
        var ref;
        mutate({
            examination_subject_id: (ref = data.examination_subject_id) === null || ref === void 0 ? void 0 : ref.value,
            note: data.note
        });
    };
    (0,react.useEffect)(function() {
        if (isOpen) {
            reset({});
            refetch();
        }
    }, [
        isOpen,
        refetch,
        reset
    ]);
    var closeModal = function() {
        setIsOpen(false);
        reset({});
    };
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SappDrawerV2/* default */.Z, {
        open: isOpen,
        title: "Change my exam date",
        handleCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "examination_subject_id",
                        render: function(param) {
                            var _field = param.field, onChange = _field.onChange, value = _field.value;
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "mb-2 block text-base font-medium",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "New Exam Date"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-2 text-red-500",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    errors.examination_subject_id && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 text-red-500",
                                        children: (ref = errors.examination_subject_id) === null || ref === void 0 ? void 0 : ref.message
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HookFormSelect/* default */.Z, {
                                        isClearable: true,
                                        classParent: "w-full md:max-w-full",
                                        placeholder: "Exam Date",
                                        options: options,
                                        required: true,
                                        noOptionsMessage: function() {
                                            return "No data";
                                        },
                                        onChange: function(e) {
                                            return onChange(e === undefined || null ? {} : e);
                                        },
                                        value: value !== null && value !== void 0 ? value : null,
                                        onMenuScrollToBottom: hasNextPage && fetchNextPage
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        className: "mt-1 inline-block",
                                        children: "You can only change the exam date up to two times."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        className: "block",
                                        children: remainingChanges ? "Remaining ".concat(pluralize("change", remainingChanges), ": ").concat(remainingChanges) : ""
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "mb-2 block text-base font-medium",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Note"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-2 text-red-500",
                                        children: "*"
                                    })
                                ]
                            }),
                            errors.note && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-2 text-red-500",
                                children: errors.note.message
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                control: control,
                                name: "note",
                                render: function(param) {
                                    var onChange = param.field.onChange;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(upload/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getUploadProps(onChange)), {
                                        multiple: false,
                                        maxCount: 1,
                                        fileList: fileList,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadOutlined/* default */.Z, {}),
                                            disabled: ((ref5 = options === null || options === void 0 ? void 0 : options.length) !== null && ref5 !== void 0 ? ref5 : 0) <= 0,
                                            children: "Please upload your exam registration evidence."
                                        })
                                    }));
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute bottom-6 right-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText/* default */.Z, {
                        title: "Cancel",
                        onClick: closeModal,
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SappButton/* default */.Z, {
                        disabled: ((ref6 = options === null || options === void 0 ? void 0 : options.length) !== null && ref6 !== void 0 ? ref6 : 0) <= 0,
                        size: "medium",
                        title: "Save",
                        loading: isChangingLoad,
                        onClick: function() {
                            if ((exams === null || exams === void 0 ? void 0 : exams.current_exam_name) === "") {
                                handleSubmit(onSubmit)();
                            } else {
                                setOpenConfirmModal(true);
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SappModalV3/* default */.Z, {
                open: openConfirmModal,
                cancelButtonCaption: "No",
                okButtonCaption: "Change Anyway",
                handleCancel: function() {
                    return setOpenConfirmModal(false);
                },
                onOk: handleSubmit(onSubmit, function(errors) {
                    if (errors) {
                        setOpenConfirmModal(false);
                    }
                }),
                fullWidthBtn: true,
                buttonSize: "extra",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AlertTriagle */.E5, {}),
                header: "Are you sure?",
                loading: isChangingLoad,
                children: [
                    "Your learning progress in the Revision class for the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm font-medium text-bw-1",
                        children: exams === null || exams === void 0 ? void 0 : exams.current_exam_name
                    }),
                    " ",
                    "exam cannot be saved. Do you want to continue making changes?"
                ]
            })
        ]
    });
};
/* harmony default export */ var ExamInformation_ExamEditDrawer = (ExamEditDrawer);


/***/ }),

/***/ 34194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52621);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97478);
/* harmony import */ var src_pages_api_class__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14577);
/* harmony import */ var src_pages_api_queryKey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8590);





var useSelectExams = function(courseId) {
    var ref;
    var DEFAULT_PAGESIZE = 10;
    var DEFAULT_PAGEINDEX = 1;
    var getExams = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var res;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            src_pages_api_class__WEBPACK_IMPORTED_MODULE_1__/* .ClassAPI.getExams */ .L.getExams(courseId, {
                                page_index: DEFAULT_PAGEINDEX,
                                page_size: DEFAULT_PAGESIZE
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function getExams() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery)({
        queryKey: [
            src_pages_api_queryKey__WEBPACK_IMPORTED_MODULE_2__/* .ClassKey.ExamList */ .qF.ExamList
        ],
        queryFn: getExams,
        enabled: !!courseId,
        getNextPageParam: function(lastPage) {
            var ref, ref1;
            return (lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.metadata) === null || ref === void 0 ? void 0 : ref.page_index) < (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.metadata) === null || ref1 === void 0 ? void 0 : ref1.total_pages) ? (lastPage === null || lastPage === void 0 ? void 0 : lastPage.metadata.page_index) + 1 : undefined;
        },
        refetchOnWindowFocus: false,
        retry: 0
    }), data = ref1.data, hasNextPage = ref1.hasNextPage, fetchNextPage = ref1.fetchNextPage, isLoading = ref1.isLoading, refetch = ref1.refetch;
    return {
        exams: data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref[0],
        hasNextPage: hasNextPage,
        fetchNextPage: fetchNextPage,
        isLoading: isLoading,
        refetch: refetch
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSelectExams);


/***/ }),

/***/ 14577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ClassAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73782);
/* harmony import */ var _components_mycourses_LearningResource__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61193);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91002);



var ClassAPI = /*#__PURE__*/ function() {
    "use strict";
    function ClassAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, ClassAPI);
    }
    ClassAPI.getAllResultOfQuiz = function getAllResultOfQuiz(id, quiz_id, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._i)("".concat(_components_mycourses_LearningResource__WEBPACK_IMPORTED_MODULE_0__/* .apiURL */ .Q, "/classes/").concat(id, "/result/").concat(quiz_id), {
            params: params
        });
    };
    ClassAPI.getExams = function getExams(id, params) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._i)("".concat(_components_mycourses_LearningResource__WEBPACK_IMPORTED_MODULE_0__/* .apiURL */ .Q, "/classes/").concat(id, "/examination"), {
            method: "GET",
            params: params
        });
    };
    ClassAPI.changeExamDate = function changeExamDate(id, data) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_1__/* .fetchFormData */ .Ji)({
            url: "".concat(_components_mycourses_LearningResource__WEBPACK_IMPORTED_MODULE_0__/* .apiURL */ .Q, "/classes/").concat(id, "/examination"),
            method: "PUT",
            formData: data
        });
    };
    ClassAPI.getExamInfo = function getExamInfo(id) {
        return (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_1__/* .fetcher */ ._i)("".concat(_components_mycourses_LearningResource__WEBPACK_IMPORTED_MODULE_0__/* .apiURL */ .Q, "/classes/").concat(id, "/exam-info"), {
            method: "GET"
        });
    };
    return ClassAPI;
}();


/***/ }),

/***/ 8590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ UserKey; },
/* harmony export */   "PW": function() { return /* binding */ ProgressKey; },
/* harmony export */   "Xn": function() { return /* binding */ StudentKey; },
/* harmony export */   "_3": function() { return /* binding */ TeacherKey; },
/* harmony export */   "qF": function() { return /* binding */ ClassKey; },
/* harmony export */   "wQ": function() { return /* binding */ CourseKey; }
/* harmony export */ });
/**
 ** This file is for storing Tanstack Query
 */ var CourseKey = {
    ResultsList: "courseResultList",
    SectionList: "courseSectionList",
    SubsectionList: "courseSubsectionList",
    UnitList: "courseUnitList",
    ActivityList: "courseActivityList"
};
var ClassKey = {
    ExamList: "classExamList",
    ExamInfo: "examInfo"
};
var UserKey = {
    ExamList: "userExamList"
};
var TeacherKey = {
    MyClass: "myClass",
    ScheduleRequest: "teacherScheduleRequest"
};
var StudentKey = {
    Student: "student",
    StudentsTestResult: "studentsTestResult",
    ChapterTest: "chapterTest"
};
var ProgressKey = {
    ProgressList: "progressList",
    ProgressDetail: "progressDetail"
};


/***/ }),

/***/ 7847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UserType; }
/* harmony export */ });
/* unused harmony export IUserStatus */
var UserType;
(function(UserType) {
    UserType["STUDENT"] = "STUDENT";
    UserType["TEACHER"] = "TEACHER";
})(UserType || (UserType = {}));
var IUserStatus;
(function(IUserStatus) {
    IUserStatus["ACTIVE"] = "ACTIVE";
})(IUserStatus || (IUserStatus = {}));


/***/ })

}]);